import { z } from "zod";
import { OkDataSchema, ToolModeSchema } from "./common.js";
import { AgentIdSchema } from "./primitives.js";

const ToolPermissionSchema = z
  .object({
    tool: z.string().min(1),
    label: z.string().min(1),
    description: z.string().optional(),
    mode: ToolModeSchema,
  })
  .strict();

export const PermissionListPayloadSchema = z.object({ agentId: AgentIdSchema }).strict();
export const PermissionListDataSchema = z.object({ tools: z.array(ToolPermissionSchema) }).strict();
export const PermissionSetPayloadSchema = z
  .object({
    agentId: AgentIdSchema,
    tool: z.string().min(1),
    mode: ToolModeSchema,
  })
  .strict();
export const PermissionSetDataSchema = OkDataSchema;

export type ToolPermission = z.infer<typeof ToolPermissionSchema>;
